import {Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {TileHistoryService} from '../../../core/services/tile-history.service';
import {Subscription} from 'rxjs';
import {NgClass} from '@angular/common';

@Component({
    selector: 'motn-tile-history-viewport-buffer',
    templateUrl: './tile-history-viewport-buffer.component.html',
    styleUrls: ['./tile-history-viewport-buffer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
    ]
})
export class TileHistoryViewportBufferComponent implements OnInit, OnDestroy {
  @Input() extraBuffer: number = 0;

  tileHistoryActive: boolean = false;

  private chartSub: Subscription;

  constructor(
    private tileHistoryService: TileHistoryService,
  ) {
  }

  ngOnInit(): void {
    this.tileHistoryService.drawerActive$.subscribe(
      (active) => {
        this.tileHistoryActive = active;
      },
    );
  }

  ngOnDestroy() {
    this.chartSub?.unsubscribe();
  }
}
